export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 180 },
  { key: '2', headerName: 'Category Code', field: 'id', hide: false, width: 180 },
  { key: '3', headerName: 'Category', field: 'name', hide: false, width: 450 },
  { key: '4', headerName: 'Status', field: 'status', hide: false, width: 250 },
];
